import clsx from "clsx";
import getPlayerContent from "@/domains/chat/helpers/getPlayerContent";
import getPlayerTitleContent from "@/domains/chat/helpers/getPlayerTitleContent.ts";
import type { MessageProps } from "@/domains/chat/helpers/messageProps";
import Time from "@/domains/chat/components/chat/messages/parts/Time";

export default function ChatFactionOocMessage({ message, settings }: MessageProps) {
  const { showTime, messageHeader } = settings;

  return (
    <div className={clsx("overflow-clip w-full")}>
      <div className={clsx("font-bold text-[#2C7DE8]", { inline: !messageHeader })}>
        {showTime && <Time date={message.date} />}{" "}
        <span>
          [F]
          {getPlayerTitleContent(message)}
          {getPlayerContent(message)}
        </span>
        {": "}
      </div>
      <div className={clsx("text-white", { inline: !messageHeader })}>
        (( {message.message.content} ))
      </div>
    </div>
  );
}
